import React, { useEffect,useState } from "react";
import { Modal } from "antd";
import { Link, useNavigate } from "react-router-dom";

import "./nujobsdashboard.scss";
import JobListingSearchResults from "../../../landing/nujobs/jobListingSearchResults";
import useNuJobsStore from "../../../store/nujobs.store";
import useNuJobDetailsStore from "../../../store/nujobsdetails.store";
import MyRecentSearches from "../nujobsMyRecentSearches";
import NUJobsMyRecentSearches from "../nujobsMyRecentSearches";
import NuJobsJobListingsSearch from "../nujobListingSearch";
import NuJobsDashboardStats from "../nujobsdashboardstats"
import NuJobsRecentlyViewed from "../nujobsdashboardRecenltyViewed";
import NuJobsMatchingJobs from "../nujobsdashboardMatchingJobs";
import NuJobsApplyCheck from "../nujobsdashboardApplyCheck";
import NuJobsSignedInFooter from "../nuJobsSignedInFooter";

function NuJobsDashboard() {
    const navigate = useNavigate();


  const { currentSearch,applyNowPopUpRouting,resetCurrentSearch } = useNuJobsStore(); 
  const { nuJobsGetIncompleteJds} = useNuJobDetailsStore(); 


  //init  
  useEffect(() => {
    //console.log("In Nujobs Dashboard", applyNowPopUpRouting,currentSearch)
    resetCurrentSearch()
    nuJobsGetIncompleteJds()
    }, []);

  return(
        <div className="nujobsdashboard-wrapper">
                    <div className="search-container">
                        <NuJobsJobListingsSearch resultHandler ={()=>  navigate(`/nujobshome/nujobsSearchResultHandler`)} loggedIn = {true}/>
                    </div>
                    <div className="activity-container">
                        <NuJobsDashboardStats/>
                    </div>    
                    <div className="activity-container">
                        <NuJobsApplyCheck/>
                    </div>                         
                    <div className="activity-container">
                        <NuJobsMatchingJobs/>
                    </div>          
                 
                    <div className="activity-container">
                        <NuJobsRecentlyViewed/>
                    </div>
                    <div className="activity-container">
                        <NUJobsMyRecentSearches/>
                    </div>   
                    <div className="activity-container">
                        <NuJobsSignedInFooter/>
                    </div>                                                            
        </div>
      
    );
}

export default NuJobsDashboard;
